import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Modal, ModalFooter, Table, Image } from "react-bootstrap";
import Camera from "../studentAdmission/camera"
import axios, { post } from "axios";


class GatePassModal extends Component {
    constructor() {
        super();
        this.state = {
            camera: false,
            cameraFileOpen: "",
            studentLogoFilePath: "",
            studentImagePreviewUrl: "",
            studentLogoFilePath: "",
            file: ""

        }
    }



    fileUpload(file, stream) {
        console.log("fileupload", file, stream);
        const url = "https://rizee.in/mobile1.php?uploadRegistraionImage=true";
        const formData = new FormData();
        formData.append("file", file);
        formData.append("stream", stream);
        const config = {
            headers: {
                "content-type": "application/x-www-form-urlencoded",
            },
        };

        return post(url, formData, config);
    }

    parenthandleinputchange = async (e) => {
        let reader = new FileReader();

        let file = {
            lastModified: "1683974399048",
            name: "testing.jpeg",
            size: "99768",
            type: "image/jpeg",
            webkitRelativePath: "",
            filename: "testing.jpeg",
            mimetype: "image/jpeg",

        }

        let fobj = {
            stream: e,
            filename: "testing.jpeg",
            mimetype: "image/jpeg",
        };


        const upload = await this.fileUpload(file, fobj.stream);

        console.log("upload",upload.data);

        if (upload.data.result == "success") {

            this.setState({
                studentLogoFilePath: upload.data.filename,
                studentImagePreviewUrl: e,
            });
        }
    }

    render() {
        console.log("hhhh",this.state);
        return (
            <>
                <Modal
                    {...this.props}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title className="modal-title">Gate Pass </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col sm={6}>
                                    <h6>Enter Reciever Name</h6>
                                    <input type="text" />
                                </Col>
                                <Col>
                                    {/* <div style={{width:"120px", height:"160px"}} className="border border-dark"></div> */}
                                    <Button onClick={() => this.setState({ camera: true })}>Capture image</Button>
                                    {this.state.studentImagePreviewUrl ?
                                        (
                                            <Image src={`${this.state.studentImagePreviewUrl}`} style={{ width: '180px', height: "30vh" }} />

                                        ) : ""}
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </Modal>
                <Camera
                    stateData={this.state}
                    show={this.state.camera}
                    parenthandleinputchange={this.parenthandleinputchange}
                    onHide={() => this.setState({ camera: false })}
                />
            </>
        )
    }
}
export default GatePassModal;